module.exports = __webpack_public_path__ + "static/media/imagelibrary.98255820.svg";